import './index.scss'
$("header .nav a").eq(2).addClass("active")